import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { DeleteLeadItem, UpdateLeadItem } from '../../../store/actions/new/leadDataAction';
import NoContentFound from '../../default/not-found/notFound';
import { ShimmerSocialPost, ShimmerTable } from 'react-shimmer-effects';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ShimmerImage from '../../default/popup/shimmerImage/shimmerImage';
import { Link } from 'react-router-dom';
import ReactTimeAgo from 'react-time-ago';
import { PrismTimeFormatter } from '../../default/utils/timeFormatter';
import { InitialAvatar } from '../../default/utils/defaultAvatar';

const SingleLeadData = ({ popupItemId = '', onClose }) => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [copyIcons, setCopyIcons] = useState(new Map());
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (!event.target.closest('.lead-dropdown') &&
            !event.target.closest('.dropdown-toggle-btn')) {
            setOpenDropdown(null);
        }
    };
    useEffect(() => {
        // dropdown click outside detector
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    })

    const { id } = useParams();
    const [cardId, setCardId] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [leadData, setLeadData] = useState(null);

    const store = useSelector((state) => state.leadDataReducer);
    const { data } = store.leadAllData;
    const leadDataList = leadData || '';


    useEffect(() => {
        // Set cardId first
        const newCardId = popupItemId || id;
        setCardId(newCardId);
    }, [id, popupItemId]);

    // Separate useEffect for fetching data
    useEffect(() => {
        if (!cardId) return; // Don't fetch if cardId is not set

        const fetchCardData = async () => {
            if (data && data.length > 0) {
                const foundData = data.find(item => String(item.id) === String(cardId));
                if (foundData) {
                    setLeadData(foundData);
                    setIsLoading(false);
                } else {
                    try {
                        const response = await axios.get(`/prospector?id=${cardId}`);
                        if (response.data && response.data.data && response.data.data.length > 0) {
                            setLeadData(response.data.data[0]);
                            setIsLoading(false);
                        } else {
                            setLeadData(null);
                            setIsLoading(false);
                        }
                    } catch (error) {
                        console.error('Error fetching card data:', error);
                        setLeadData(null);
                        setIsLoading(false);
                    }
                }
            } else {
                try {
                    const response = await axios.get(`/prospector?id=${cardId}`);
                    if (response.data && response.data.data && response.data.data.length > 0) {
                        setLeadData(response.data.data[0]);
                        setIsLoading(false);
                    } else {
                        setLeadData(null);
                        setIsLoading(false);
                    }
                } catch (error) {
                    console.error('Error fetching card data:', error);
                    setLeadData(null);
                    setIsLoading(false);
                }
            }
        };

        fetchCardData();
    }, [cardId, data]); // Depend on cardId and data

    // Truncate Text
    const truncateText = (text, maxLength = 32) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;

        const startLength = Math.floor(maxLength / 2) - 2;
        const endLength = Math.floor(maxLength / 2) - 2;

        return `${text.substring(0, startLength)}...${text.substring(text.length - endLength)}`;
    };
    // Add this function near your other utility functions
    const copyToClipboard = async (text, buttonId) => {
        try {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(text);
                setCopyIcons(prev => new Map(prev).set(buttonId, "ri-check-double-line"));
                return true;
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                setCopyIcons(prev => new Map(prev).set(buttonId, "ri-check-double-line"));
                return true;
            }
        } catch (err) {
            console.error('Failed to copy: ', err);
            return false;
        }
        finally {
            // Reset the message after 2 seconds
            setTimeout(() => {
                setCopyIcons(prev => new Map(prev).set(buttonId, "ri-file-copy-line"));
            }, 2000);
        }
    };

    // Delete lead
    const MySwal = withReactContent(Swal)
    const handleDeleteLead = () => {
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden";
            },
            willClose: () => {
                document.body.style.overflow = "";
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await dispatch(DeleteLeadItem(cardId));
                    if (response?.status === 200) {
                        if (onClose) {
                            onClose();
                        } else {
                            navigate('/lead');
                        }
                    }
                } catch (error) {
                    console.error('Error deleting lead:', error);
                }
            }
        });

    }
    return (
        <>
            {leadData && isLoading === false ? (
                <>
                    <div className="connection-header lead-sng-header">
                        <h3></h3>
                        <div className="filter-wrapper">
                            <Link to={`/lead/update/${cardId}`} className="list-filter add-new-btn">
                                <i className="ri-edit-box-line"></i>
                                <span>Edit</span>
                            </Link>
                            <div className="category-dropdown">
                                <div className="list-edit-dropdown lead-dropdown">
                                    <i
                                        className="ri-more-2-fill"
                                        onClick={() => toggleDropdown(999999)}
                                    ></i>
                                    {openDropdown === 999999 && (
                                        <ul>
                                            <li><Link onClick={() => handleDeleteLead()}>Delete</Link></li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='sng-lead-item-view'>
                        <div className='card-profile-photo'>
                            {leadData.photo ? (
                                <ShimmerImage
                                    src={leadData.photo}
                                    alt={leadData.firstName}
                                    width={162}
                                />
                            ) : (
                                <InitialAvatar
                                    title={`${leadData.firstName} ${leadData.lastName}`}
                                    size={162}
                                />
                            )}
                            <div className='card-profile-info'>
                                <h4><span>{leadData.firstName} {leadData.lastName}</span></h4>
                                <p>{leadData.title} {leadData.company && leadData.title ? '•' : ''} {leadData.company}</p>
                            </div>
                        </div>
                        <div className='lead-header'>
                            {leadData.adi_info.website !== null && (
                                <div className="inline-flex-item">
                                    <button
                                        className="lead_action_menu icon-button list-btn dropdown-toggle-btn"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            toggleDropdown(("lead_website"));
                                        }}
                                    >
                                        < i className="ri-global-fill"></i>

                                    </button>
                                    <span>Website</span>

                                    <div className='list-edit-dropdown lead-dropdown'>
                                        {openDropdown === ("lead_website") && (
                                            <ul>
                                                {leadData.adi_info.website.map((website, index) => (
                                                    <div key={website.value} className="list-link-wrapper">
                                                        <Link key={website.value} to={website.value} target='_blank'>
                                                            {truncateText(website.value)}
                                                        </Link>
                                                        <button
                                                            className="copy-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                copyToClipboard(website.value, `website-${index}-${website.value}`);
                                                            }}
                                                        >
                                                            <i className={copyIcons.get(`website-${index}-${website.value}`) || "ri-file-copy-line"}></i>
                                                        </button>
                                                    </div>

                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            )}
                            {leadData.adi_info.email !== null && (
                                <div className="inline-flex-item">
                                    <button
                                        className="lead_action_menu icon-button list-btn dropdown-toggle-btn"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            toggleDropdown(("lead_email"));
                                        }}
                                    >
                                        < i className="ri-mail-line"></i>
                                    </button>
                                    <span>Email</span>
                                    <div className='list-edit-dropdown lead-dropdown'>
                                        {openDropdown === ("lead_email") && (
                                            <ul>
                                                {leadData.adi_info.email.map((email, index) => (
                                                    <div key={email.value} className="list-link-wrapper">
                                                        <Link to={`mailto:${email.value}`}>
                                                            {truncateText(email.value)}
                                                        </Link>
                                                        <button
                                                            className="copy-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                copyToClipboard(email.value, `email-${index}-${email.value}`);
                                                            }}
                                                        >
                                                            <i className={copyIcons.get(`email-${index}-${email.value}`) || "ri-file-copy-line"}></i>
                                                        </button>
                                                    </div>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            )}
                            {leadData.adi_info.phone !== null && (
                                <div className="inline-flex-item">
                                    <button
                                        className="lead_action_menu icon-button list-btn dropdown-toggle-btn"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            toggleDropdown(("lead_phone"));
                                        }}
                                    >
                                        < i className="ri-phone-line"></i>
                                    </button>
                                    <span>Phone</span>
                                    <div className='list-edit-dropdown lead-dropdown'>
                                        {openDropdown === ("lead_phone") && (
                                            <ul>
                                                {leadData.adi_info.phone.map((phone, index) => (
                                                    <div key={phone.value} className="list-link-wrapper">
                                                        <Link key={phone.value} to={`tel:${phone.value}`}>
                                                            {phone.value}
                                                        </Link>
                                                        <button
                                                            className="copy-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                copyToClipboard(phone.value, `phone-${index}-${phone.value}`);
                                                            }}
                                                        >
                                                            <i className={copyIcons.get(`phone-${index}-${phone.value}`) || "ri-file-copy-line"}></i>
                                                        </button>
                                                    </div>

                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='info-wrapper'>
                            <div className='info-links'>
                                <h3>Contact information</h3>
                                <div className="inline-flex-leadData">
                                    <i className="ri-global-line"></i>
                                    <div className='list-edit-dropdown'>
                                        {leadData.adi_info.website !== null && (
                                            <ul>
                                                {leadData.adi_info.website.map((website, index) => (
                                                    <div key={website.value} className="list-link-wrapper">
                                                        <Link key={website.value} to={website.value} target='_blank'>
                                                            {truncateText(website.value)}
                                                            {website.title && (
                                                                <>
                                                                    <span className="cnt-type">{' • '}{website.title}</span>
                                                                </>
                                                            )}
                                                        </Link>
                                                        <button
                                                            className="copy-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                copyToClipboard(website.value, `website-${index}-${website.value}`);
                                                            }}
                                                        >
                                                            <i className={copyIcons.get(`website-${index}-${website.value}`) || "ri-file-copy-line"}></i>
                                                        </button>
                                                    </div>

                                                ))}
                                            </ul>
                                        )}
                                        {(!leadData.adi_info.website || leadData.adi_info.website.length === 0) && (
                                            <Link className='update-lead-btn' to={`/lead/update/${cardId}`}>
                                                Add Website
                                            </Link>
                                        )}
                                    </div>
                                </div>
                                <div className="inline-flex-leadData">
                                    <i className="ri-mail-line"></i>
                                    <div className='list-edit-dropdown'>
                                        {leadData.adi_info.email !== null && (
                                            <ul>
                                                {leadData.adi_info.email.map((email, index) => (
                                                    <div key={email.value} className="list-link-wrapper">
                                                        <Link to={`mailto:${email.value}`}>
                                                            {truncateText(email.value)}
                                                            {email.title && (
                                                                <>
                                                                    <span className="cnt-type">{' • '}{email.title}</span>
                                                                </>
                                                            )}
                                                        </Link>
                                                        <button
                                                            className="copy-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                copyToClipboard(email.value, `email-${index}-${email.value}`);
                                                            }}
                                                        >
                                                            <i className={copyIcons.get(`email-${index}-${email.value}`) || "ri-file-copy-line"}></i>
                                                        </button>
                                                    </div>
                                                ))}
                                            </ul>

                                        )}
                                        {(!leadData.adi_info.email || leadData.adi_info.email.length === 0) && (
                                            <Link className='update-lead-btn' to={`/lead/update/${cardId}`}>
                                                Add Email
                                            </Link>
                                        )}
                                    </div>
                                </div>
                                <div className="inline-flex-leadData">
                                    <i className="ri-phone-line"></i>
                                    <div className='list-edit-dropdown'>
                                        {leadData.adi_info.phone !== null && (
                                            <ul>
                                                {leadData.adi_info.phone.map((phone, index) => (
                                                    <div key={phone.value} className="list-link-wrapper">
                                                        <Link key={phone.value} to={`tel:${phone.value}`}>
                                                            {phone.value}
                                                            {phone.title && (
                                                                <>
                                                                    <span className="cnt-type">{' • '}{phone.title}</span>
                                                                </>
                                                            )}
                                                        </Link>
                                                        <button
                                                            className="copy-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                copyToClipboard(phone.value, `phone-${index}-${phone.value}`);
                                                            }}
                                                        >
                                                            <i className={copyIcons.get(`phone-${index}-${phone.value}`) || "ri-file-copy-line"}></i>
                                                        </button>
                                                    </div>

                                                ))}
                                            </ul>
                                        )}
                                        {(!leadData.adi_info.phone || leadData.adi_info.phone.length === 0) && (
                                            <Link className='update-lead-btn' to={`/lead/update/${cardId}`}>
                                                Add Phone
                                            </Link>
                                        )}
                                    </div>
                                </div>
                                <div className="inline-flex-leadData">
                                    <i className="ri-map-pin-line"></i>
                                    <div className='list-edit-dropdown'>
                                        {leadData.adi_info.address !== null && (
                                            <ul>
                                                {leadData.adi_info.address.map((address, index) => (
                                                    <div key={address.value} className="list-link-wrapper">
                                                        <div className='update-lead-btn' key={address.value} >
                                                            {address.value}
                                                            {address.title && (
                                                                <>
                                                                    <span className="cnt-type">{' • '}{address.title}</span>
                                                                </>
                                                            )}
                                                        </div>
                                                        <button
                                                            className="copy-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                copyToClipboard(address.value, `address-${index}-${address.value}`);
                                                            }}
                                                        >
                                                            <i className={copyIcons.get(`address-${index}-${address.value}`) || "ri-file-copy-line"}></i>
                                                        </button>
                                                    </div>

                                                ))}
                                            </ul>
                                        )}
                                        {(!leadData.adi_info.address || leadData.adi_info.address.length === 0) && (
                                            <Link className='update-lead-btn' to={`/lead/update/${cardId}`}>
                                                Add Address
                                            </Link>
                                        )}
                                    </div>
                                </div>
                                <div className="inline-flex-leadData">
                                    <i className="ri-sticky-note-line"></i>
                                    <div className='list-edit-dropdown'>
                                        {leadData.adi_info.note !== null && (
                                            <ul>
                                                {leadData.adi_info.note.map((note, index) => (
                                                    <div key={note.value} className="list-link-wrapper">
                                                        <div className='update-lead-btn' key={note.value}>
                                                            {note.value}
                                                            {note.title && (
                                                                <>
                                                                    <span className="cnt-type">{' • '}{note.title}</span>
                                                                </>
                                                            )}
                                                        </div>
                                                        <button
                                                            className="copy-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                copyToClipboard(note.value, `note-${index}-${note.value}`);
                                                            }}
                                                        >
                                                            <i className={copyIcons.get(`note-${index}-${note.value}`) || "ri-file-copy-line"}></i>
                                                        </button>
                                                    </div>

                                                ))}
                                            </ul>
                                        )}
                                        {(!leadData.adi_info.note || leadData.adi_info.note.length === 0) && (
                                            <Link className='update-lead-btn' to={`/lead/update/${cardId}`}>
                                                Add Note
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='info-history'>
                                <h3>History</h3>
                                {leadData.update !== null && (
                                    <p>Last edited<span className='date-format'>&nbsp;•&nbsp;
                                        {PrismTimeFormatter(leadData.update)}
                                    </span></p>
                                )}
                                <p>Added to contacts<span className='date-format'>&nbsp;•&nbsp;{PrismTimeFormatter(leadData.date)}</span></p>
                            </div>

                            {Array.isArray(leadData.cards) && leadData.cards.length > 0 && (
                                <div className='info-cards-history'>
                                    <h3>Visited Cards</h3>
                                    <ul>
                                        {leadData.cards && leadData.cards.map((item, index) => (
                                            <li>- <Link to={`https://cardiast.app/${item.cardID}`} key="index" target='_blank'>{item.cardName}<span className='date-format'>&nbsp;•&nbsp;{PrismTimeFormatter(item.date)}</span></Link></li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            ) : isLoading === false && (
                <NoContentFound title="Invalid Lead ID" />
            )}
            {isLoading &&
                <>
                    <ShimmerSocialPost type="text" title />
                </>
            }
        </>
    );
};

export default SingleLeadData;